import { OwcCheckbox, OwcTypography } from "@one/react";
import { react18WorkaroundProps } from "../../../../utils/constants/constants";
import { useCallback } from "react";
import { STYLES } from "../constants";
import { ResourceHeaderProps } from "../types";

const ResourceHeader: React.FC<ResourceHeaderProps> = ({
  totalEquipment,
  selectedCount,
  onSelectAll,
  isAllSelected,
  isIndeterminate,
}) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onSelectAll(!isAllSelected);
    },
    [isAllSelected, onSelectAll],
  );

  return (
    <div className="md-resource-header-template-title">
      <div className="md-resource-header-template-name">
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <OwcCheckbox
            checked={isAllSelected}
            indeterminate={isIndeterminate}
            onClick={handleClick}
            style={{ marginRight: "4px" }}
            {...react18WorkaroundProps}
          />
          <OwcTypography
            variant="body2"
            style={{ marginRight: "10px" }}
            {...react18WorkaroundProps}
          >
            Select All ({selectedCount}/{totalEquipment})
          </OwcTypography>
          <span style={STYLES.resourceHeaderBadge}>{totalEquipment}</span>
        </div>
      </div>
    </div>
  );
};

export default ResourceHeader;
